import { assertValidQuizDefinition } from "@quiz/quiz-core";
import { demoQuiz } from "./quizzes/demo/quiz.config.js";
import { englishDomQuiz } from "./quizzes/englishdom/quiz.config.js";
import { customFallbackQuiz, directStartQuiz, levelTestQuiz } from "./quizzes/level-test/quiz.config.js";
import { personalPlanQuiz } from "./quizzes/personal-plan/quiz.config.js";
import { halloweenQuiz } from "./quizzes/halloween/quiz.config.js";
import { mistychnaUkrainaQuiz } from "./quizzes/mistychna-ukraina/quiz.config.js";
import { instagramLessonQuiz } from "./quizzes/instagram-lesson/quiz.config.js";
export const quizzes = [demoQuiz, englishDomQuiz, personalPlanQuiz, halloweenQuiz, mistychnaUkrainaQuiz, instagramLessonQuiz, levelTestQuiz, directStartQuiz, customFallbackQuiz];
for (const quiz of quizzes) {
    assertValidQuizDefinition(quiz);
}
export const quizRegistry = Object.fromEntries(quizzes.map((quiz) => [quiz.slug, quiz]));
export function getQuizBySlug(slug) {
    return quizRegistry[slug];
}
export function getQuizByIdAndVersion(id, version) {
    return quizzes.find((quiz) => quiz.id === id && quiz.version === version);
}
export function assertUniqueSlugs() {
    const seen = new Set();
    for (const quiz of quizzes) {
        if (seen.has(quiz.slug))
            throw new Error(`Duplicate quiz slug "${quiz.slug}"`);
        seen.add(quiz.slug);
    }
}
assertUniqueSlugs();
